import { formatChartValue } from './resumoDgChartValues'

// O gráfico e a tabela consomem a mesma análise local para manter taxa e N consistentes offline.
export const ANALYSIS_CHART_TITLES = {
  general: 'Taxa de Prenhez à IATF',
  order: 'Taxa de Prenhez à IATF por Ordem',
  age: 'Taxa de Prenhez à IATF por Idade',
  ecc: 'Taxa de Prenhez à IATF por Escore (ECC)',
  breed: 'Taxa de Prenhez à IATF por Raça',
  bull: 'Taxa de Prenhez à IATF por Touro',
}

export const getAnalysisChartTitle = (analysis) =>
  ANALYSIS_CHART_TITLES[analysis?.key] || analysis?.label || ''

export const buildAnalysisChartBars = (analysis) =>
  (analysis?.rows || []).map((row) => {
    const rate = Number.isFinite(row.pregnancyRate) ? row.pregnancyRate : 0
    const n = Number.isFinite(row.total) ? row.total : 0
    return {
      label: row.group,
      rate,
      n,
      rateLabel: formatChartValue(rate, true),
      nLabel: formatChartValue(n),
    }
  })
